module.exports = new __parcel__URL__("friends.9562da31.jpeg").toString();